import Applications from './License.container';
export default Applications;
